import { ExtratoResponse } from './extratoResponse';

export const EXTRATO_RANGE = 'EXTRATO_RANGE';

export interface ExtratoState {
  Extrato?: ExtratoResponse[];
}

export interface ExtratoRangeAction {
  type: typeof EXTRATO_RANGE,
  payload: ExtratoResponse[]
}

export type ExtratoActionTypes =
  ExtratoRangeAction